import React from 'react';
import { useTranslation, withTranslation } from "react-i18next"
import { Grid } from '@mui/material/'
import '../../utils/common.scss';
import SETTINGS from '../../utils/constants';

const Booking=()=>{
    const {t} = useTranslation();

    return(
        <Grid container direction='column' align='center' justifyContent='center' sx={{marginTop: '60px'}}>
            <Grid item className='general-title'>{t('booking.title')}</Grid>
            <Grid item className='center-item' sx={{width: '100%', padding: '10px 0px'}}>
                <iframe
                    title="Jane App Book Online"
                    src={SETTINGS.JANE_BOOKING_EMBED}
                    frameBorder="0"
                    scrolling="no"
                    width="177"
                    height="28"
                />
            </Grid>
            <Grid item className='general-text' style={{color: SETTINGS.DEEP_COLOR}}>
                {t('booking.hoursTitle')}
            </Grid>
            <Grid item className='general-text' style={{color: SETTINGS.DEEP_COLOR}}>
                {t('booking.hours1')}
            </Grid>
            <Grid item className='general-text' style={{color: SETTINGS.DEEP_COLOR}}>
                {t('booking.hours2')}
            </Grid>
        </Grid>
    )
}

export default withTranslation()(Booking)
